{
  "title": "How to Configure Competition Categories",
  "description": "Create, edit, and archive competition categories for teams to choose from at registration.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, the competition has a set of categories participants can choose from, with an optional capacity figure recorded per category.",
  "roleNote": "Competition Admin",
  "prerequisites": ["You have admin access to this competition"],
  "pathLabel": "Organizer Console → Competition Settings → Categories",
  "steps": [
    {
      "title": "1. Add a category",
      "description": "Fill in the category name (required) and a description (optional), e.g. \"Open Track\" or \"Sponsor-Assigned Track\"."
    },
    {
      "title": "2. Optionally record a planned capacity",
      "description": "The \"Capacity\" field can record the planned maximum number of teams for this category; leave it blank if you don't want to track it. Note that this number is currently stored for display/planning reference only — the system does not automatically block over-capacity registrations at team creation time. Controlling actual headcount still requires the organizer to track it manually."
    },
    {
      "title": "3. Adjust display order",
      "description": "Use the sort order value to control the order categories appear in on the registration page."
    },
    {
      "title": "4. Archive categories no longer in use",
      "description": "\"Deleting\" a category actually sets its status to \"Archived\" rather than removing it from the database — historical data for teams already registered under it is unaffected."
    }
  ],
  "afterward": [
    "Participants can see and choose from these categories when registering",
    "An archived category no longer appears in the registration form's selectable list, but existing registrations keep their original category assignment"
  ],
  "nextSteps": "Once categories are set, see \"How to Build and Publish Forms\" to create the registration form and include categories as part of it.",
  "faq": [
    {
      "q": "If I delete a category, does existing registration data under it disappear too?",
      "a": "No. \"Delete\" only sets the category's status to \"Archived\", it isn't a real deletion; existing registrations that used this category are completely unaffected — the option is just no longer offered for new registrations."
    },
    {
      "q": "Does the system automatically block new registrations once the capacity number is reached?",
      "a": "No. The \"Capacity\" field is currently for recording and display only — the system does not use it to automatically block over-capacity registrations at team-creation time. If you need to actually control headcount, you'll need to track registrations yourself and act manually as needed."
    },
    {
      "q": "Do I have to set up multiple categories?",
      "a": "No, a competition with a single category (or no category distinction at all) works fine; categories exist to let differently-scoped content (e.g. open-topic vs sponsor-assigned) be judged and reported on separately."
    }
  ]
}
